export class LastTransaction {
  storedTransaction: any;

  constructor() {}

  /**
   * @name posApp.lastTransaction#set
   * @methodOf posApp.lastTransaction
   * @param {object} transaction transaction to be saved
   * @param {string} transactionId optional transactionId if the transaction is saved
   * @returns {Void} nothing
   * @description
   * Copy & store transaction for later use
   */
  set = (transaction, transactionId) => {
    this.storedTransaction = angular.copy(transaction);
    if (transactionId) {
      this.storedTransaction._id = transactionId;
    }
  };

  /**
   * @name posApp.lastTransaction#get
   * @methodOf posApp.lastTransaction
   * @returns {object} transaction
   * @description
   * Return stored transaction, or null
   */
  get = () => this.storedTransaction;
}

/**
 * @ngdoc service
 * @name posApp.lastTransaction
 * @description
 * Store the last transaction for reprinting and to display
 */
angular.module('posApp').factory('lastTransaction', () => {
  return new LastTransaction();
});
